import { useEffect, useState } from 'react';

import { PlayerProfile } from 'pages/Dashboard/home-reads';
import { getPlayerInfo } from 'services/dashboard.service';

export type EstadoDoGestor = 'carregando' | 'erro' | 'pronto';

/**
 * Ficha de quem dá a alçada: a do usuário logado ou, na lateralidade, a do gestor substituído (regra de antes).
 * A do substituído vem do servidor; enquanto carrega ou se falhar, a alçada não é conhecida e a página não
 * mostra os cartões como "Acima da sua alçada" (PAR-86).
 */
export function useInfoDoGestor(isVacationManager: boolean, gestorSubstituido: string | undefined, userInfo: PlayerProfile | null | undefined) {
  const [infoDoSubstituido, setInfoDoSubstituido] = useState<PlayerProfile | null>(null);
  const [estadoDoSubstituido, setEstadoDoSubstituido] = useState<EstadoDoGestor>('carregando');
  const [tentativa, setTentativa] = useState(0);

  useEffect(() => {
    if (!isVacationManager || !gestorSubstituido) return;
    let ativo = true;
    setEstadoDoSubstituido('carregando');

    getPlayerInfo(gestorSubstituido)
      .then(info => {
        if (!ativo) return;
        setInfoDoSubstituido(info);
        setEstadoDoSubstituido(info ? 'pronto' : 'erro');
      })
      .catch(() => ativo && setEstadoDoSubstituido('erro'));

    return () => {
      ativo = false;
    };
  }, [isVacationManager, gestorSubstituido, tentativa]);

  return {
    info: isVacationManager ? infoDoSubstituido : userInfo,
    estado: isVacationManager ? estadoDoSubstituido : 'pronto',
    tentarDeNovo: () => setTentativa(n => n + 1),
  };
}
